import {
  type FirebaseDocRef,
  UserSettings,
  type Uuid,
} from "#customTypes/globalTypes"
import {
  type Address,
  type Attendance,
  type DatabaseObject,
  type FormData,
  IsoDate,
  type TableData,
} from "#customTypes/types"

import { UserRole } from "./authTypes"
import { QuickNotes } from "./quickNotesTypes"

export const USER_GENDERS = {
  MALE: "MALE",
  FEMALE: "FEMALE",
  OTHER: "OTHER",
} as const

export const STAFF_TITLES = ["Mr", "Ms", "Mrs"] as const
export type StaffTitle = (typeof STAFF_TITLES)[number]

export interface UserConstructor extends DatabaseObject {
  id: Uuid
  role: UserRole
  // Attendance fields can be an explicit null: cleanFormData converts empty
  // objects to null on save (Firestore convention for clearing a map field)
  attendance?: Attendance | null
  name: string
  title?: StaffTitle
  firstName: string
  lastName: string
  dob: string
  avatar: string
  gender: string
  personalPhone: string
  personalEmail: string
  primaryAddress: Address
  pinHash?: string
  teacherAttendance?: Attendance | null
  personalNotes?: QuickNotes[]
  notes?: string
  tags?: string[]
  allergies?: string[]
  settings?: UserSettings
}

// Stringify complex fields like address for display
export interface UserForTable
  extends TableData,
    Omit<UserConstructor, "primaryAddress" | "tags" | "allergies" | "pinHash"> {
  id: Uuid
  role: string
  name: string
  address: string
  phone: string
  email: string
  tags: string
  allergies: string
  hasPin: string
}

export type UserRef = FirebaseDocRef<UserConstructor>

export interface AddUserFormValues extends FormData {
  id: Uuid
  name: string
  title?: StaffTitle
  firstName: string
  lastName: string
  role: UserRole
  dob: string
  avatar: string
  gender: string
  personalPhone: string
  personalEmail: string
  primaryAddress: Address
  notes?: string
  tags?: string[]
  allergies?: string[]
}

export interface AddUserFormSubmitValues extends AddUserFormValues {
  id: Uuid
  createdAt: IsoDate
  createdBy: Uuid
  lastUpdatedAt: IsoDate
  lastUpdatedBy: Uuid
}
